module.exports = __webpack_public_path__ + "static/img/weixin_erweim1.c8fd794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin_erweim1.png
// module id = MfdS
// module chunks = 16